import { useEffect, useRef, useState } from "react";
import { Bell } from "lucide-react";
import { call, json } from "@/lib/api";
import { timeAgo } from "./shared";

const POLL_MS = 60000;

/** Topbar bell. Polls once a minute while the tab is visible; links open the related page. */
export default function NotificationBell({ user, go }) {
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const box = useRef(null);
  const load = () => call("/notifications?limit=20").then(setData).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(() => { if (document.visibilityState === "visible") load(); }, POLL_MS);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    const away = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", away);
    return () => document.removeEventListener("mousedown", away);
  }, []);
  const follow = async (n) => {
    setOpen(false);
    if (!n.read) call("/notifications/read", json("POST", { ids: [n.id] })).then(load).catch(() => {});
    const admin = ["it_admin", "super_admin"].includes(user.role);
    const { page, id } = n.link || {};
    if (page === "approvals") go("approvals");
    else if (page === "admin_ticket" && admin) go("ticket_queue", { id });
    else if (page === "ticket" || page === "admin_ticket") go("tickets", { id });
  };
  const readAll = () => call("/notifications/read", json("POST", { all: true })).then(load).catch(() => {});
  return <div className="fx-topbar-tools" ref={box}>
    <button className="fx-bell" onClick={() => { setOpen(!open); if (!open) load(); }} aria-label={`Notifications (${data.unread} unread)`} data-testid="notification-bell"><Bell size={17} />{data.unread > 0 && <span className="dot">{data.unread > 99 ? "99+" : data.unread}</span>}</button>
    {open && <div className="fx-pop" role="dialog" aria-label="Notifications">
      <div className="fx-pop-head"><span>Notifications</span>{data.unread > 0 && <button className="fx-link" onClick={readAll}>Mark all read</button>}</div>
      {data.items.length ? data.items.map((n) => <button key={n.id} className={`fx-pop-item ${n.read ? "" : "unread"}`} onClick={() => follow(n)}><strong>{n.title}</strong><span>{n.body?.slice(0, 140)}</span><br /><small>{timeAgo(n.created_at)}</small></button>)
        : <div className="fx-empty">No notifications yet.</div>}
    </div>}
  </div>;
}
